import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TobicCategoryComponent } from './tobic-category/tobic-category.component';
import { TobicDetailsComponent } from './tobic-details/tobic-details.component';
import { TobicsComponent } from './tobics/tobics.component';
import { TobicRoutingModule } from './tobic-routing.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';

  
 

@NgModule({
  declarations: [
    TobicCategoryComponent,
  TobicDetailsComponent ,
    TobicsComponent

  ],
  exports: [TobicsComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    TobicRoutingModule
  ]
})
export class TobicModule { }
